import { acompanhamento_de_resultados_finais } from "./acompanhamento-de-resultados-finais/routes";
import { calcular_resultados_finais } from "./calcular-resultados-finais/routes";
import { relatorio_final_da_escola } from "./relatorio-final-da-escola/routes";
import { encerramento_do_ano_letivo } from "./encerramento-do-ano-letivo/routes";
import { fase_concluida } from "./fase-concluida/routes";
const resultados_finais = [
  ...acompanhamento_de_resultados_finais,
  ...calcular_resultados_finais,
  ...relatorio_final_da_escola,
  ...encerramento_do_ano_letivo,
  ...fase_concluida,
];

export { resultados_finais };
